import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { COLOR, FUENTE } from './tokens';

const Seccion = ({ etiqueta, children }) => (
    <Box>
        <Typography sx={{ fontFamily: FUENTE, fontSize: 10.5, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: COLOR.azul, marginBottom: '6px' }}>
            {etiqueta}
        </Typography>
        {children}
    </Box>
);

/**
 * Botón "i" en la esquina de una tarjeta de gráfico — abre un modal con 4 secciones fijas
 * (qué muestra / ejemplo renderizado con datos simulados / cómo leerlo / análisis del
 * ejemplo). El padre debe tener position:'relative' para que este botón quede anclado a
 * su esquina.
 * @param {{
 *   titulo: string,
 *   queMuestra: string,
 *   ejemploVisual: React.ReactNode,
 *   comoLeerlo: string[],
 *   analisis: string,
 * }} props
 */
const InfoGrafico = ({ titulo, queMuestra, ejemploVisual, comoLeerlo, analisis }) => {
    const [abierto, setAbierto] = useState(false);

    return (
        <>
            <button
                type="button"
                onClick={() => setAbierto(true)}
                aria-label={`Cómo leer: ${titulo}`}
                title="Cómo leer este gráfico"
                style={{
                    position: 'absolute', top: 14, right: 16, zIndex: 1,
                    width: 20, height: 20, borderRadius: '50%', border: `1px solid ${COLOR.gris}`,
                    background: '#fff', color: COLOR.grisTexto, cursor: 'pointer', padding: 0,
                    fontFamily: FUENTE, fontSize: 12, fontWeight: 700, lineHeight: 1,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}
            >
                i
            </button>

            {abierto && (
                <Box
                    sx={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 4000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}
                    onClick={() => setAbierto(false)}
                >
                    <Box
                        sx={{ background: '#fff', borderRadius: '16px', width: 560, maxWidth: '100%', maxHeight: '88vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Box sx={{ padding: '18px 22px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexShrink: 0 }}>
                            <Typography sx={{ fontFamily: FUENTE, fontSize: 15, fontWeight: 700, color: COLOR.negro }}>{titulo}</Typography>
                            <button
                                type="button" onClick={() => setAbierto(false)} aria-label="Cerrar"
                                style={{ border: 'none', background: 'transparent', cursor: 'pointer', fontSize: 18, color: COLOR.grisTexto, lineHeight: 1, padding: 4, marginLeft: 12 }}
                            >
                                ✕
                            </button>
                        </Box>

                        <Box sx={{ padding: '20px 22px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '18px' }}>
                            <Seccion etiqueta="Qué muestra">
                                <Typography sx={{ fontFamily: FUENTE, fontSize: 13, color: COLOR.negro, lineHeight: 1.5 }}>{queMuestra}</Typography>
                            </Seccion>

                            <Seccion etiqueta="Ejemplo">
                                <Box sx={{ background: '#F8FAFC', border: '1px solid #F1F5F9', borderRadius: '10px', padding: '14px 14px 10px' }}>
                                    <Typography sx={{ fontFamily: FUENTE, fontSize: 10.5, fontStyle: 'italic', color: COLOR.grisTexto, marginBottom: '8px' }}>
                                        Ejemplo con datos simulados
                                    </Typography>
                                    {ejemploVisual}
                                </Box>
                            </Seccion>

                            <Seccion etiqueta="Cómo leerlo">
                                <Box component="ul" sx={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                    {comoLeerlo.map((item, i) => (
                                        <Typography key={i} component="li" sx={{ fontFamily: FUENTE, fontSize: 12.5, color: COLOR.negro, lineHeight: 1.5 }}>
                                            {item}
                                        </Typography>
                                    ))}
                                </Box>
                            </Seccion>

                            <Seccion etiqueta="Qué dice este ejemplo">
                                <Typography sx={{ fontFamily: FUENTE, fontSize: 12.5, color: COLOR.grisTexto, lineHeight: 1.5 }}>{analisis}</Typography>
                            </Seccion>
                        </Box>
                    </Box>
                </Box>
            )}
        </>
    );
};

export default InfoGrafico;
